<template>
  <v-container
    class="auth"
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md4
        mt-10
      >
        <v-img
          :src="logo"
          :lazy-src="logo"
          alt="AIVIA"
          max-height="90"
          contain
        />
        <v-card>
          <v-form
            v-if="!submitted"
            @submit.prevent="Login"
          >
            <v-layout
              resetpassword
              wrap
            >
              <v-flex
                xs12
                md12
              >
                <h2>{{ $t('resetpassword.resetPassword') }}</h2>
                <h5 v-if="error">
                  {{ error }}
                </h5>
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-text-field
                  id="email"
                  v-model.trim="form.email"
                  :error-messages="EmailErrors"
                  autocomplete="email"
                  name="email"
                  :label="$t('globals.email') +'*'"
                  required
                  @input="$v.form.email.$touch()"
                  @blur="$v.form.email.$touch()"
                  @keyup.enter="ResetPassword"
                />
              </v-flex>
              <v-flex
                xs12
                md12
                submit
              >
                <v-btn
                  class="primary"
                  block
                  x-large
                  :disabled="loading"
                  :loading="loading"
                  @click="ResetPassword"
                >
                  {{ $t('resetpassword.submit') }}
                </v-btn>
                <small class="forgot">
                  <router-link to="/login">
                    {{ $t('resetpassword.return') }}
                  </router-link>
                </small>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout v-if="submitted">
            <v-flex 
              verification
              xs12
              md12
            >
              <v-icon class="main-icon">
                mdi-email-outline
              </v-icon>
              <h2> {{ $t('resetpassword.reqConf') }}</h2>
              <h5>
                {{ $t('resetpassword.reqConf2') }}
              </h5>
              <email-hints />
            </v-flex>
          </v-layout>    
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, maxLength } from 'vuelidate/lib/validators'
import EmailHints from '@/views/Auth/partial/EmailHints.vue'

export default {
  name: 'ResetPassword',
  components: {
    EmailHints
  },
  mixins: [validationMixin],
  data: () => ({
    logo: require('@/images/logo-dark.png'), 
    loading: false,
    error: false,
    submitted: false,
    form: {
        email: '',
    }
  }),
  validations () {
    return {
      form: this.rules
    }
  },
  computed: {
    rules () {
      var form = {
        email: {
            required,
            email,
            maxLength: maxLength(255),
        },
      }
      return form
    },
    EmailErrors () {
      const errors = []
      if (!this.$v.form.email.$dirty) return errors
      !this.$v.form.email.required &&
        errors.push('Email is required.')
      !this.$v.form.email.required &&
        errors.push('Email is not valid.') 
      !this.$v.form.email.maxLength &&
        errors.push('Email must be max. 255 characters long.')
      return errors
    },
  },
  methods: {
    ResetPassword() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true;  
        this.$apollo.mutate({
            mutation: require('@/graphql/mutations/ResetPassword.gql'),
            variables: {
                email: this.form.email,
            }       
        }).then(data => {
            this.loading = false;
            if (data.data.forgotPassword.status == 'EMAIL_NOT_SENT') {
              this.error = 'E-Mail not found'
            } else {
              this.submitted = true;
            } 
        }).catch(error => {
            this.errorHandler(error)
            this.loading = false;  
        })
      }
    },
  }
}
</script>

<style lang="scss">

</style>
